<script>
    import ChangelogObject from '@/components/page-change-log/ChangelogObject.vue';
    import changelog from '@/changelog';

    export default {
        computed: {
            changelog() {return changelog},
        },
        components: {
            ChangelogObject: ChangelogObject,
        }
    }
</script>


<template>
    <ChangelogObject 
        v-for="(logValue, logIndex) in changelog" :key="logIndex"
        :title="logIndex"
        :value="logValue"
    />
</template>